export default __webpack_public_path__ + "static/scroll_phone_6-30c9a5915995f1ed812a5bf5e4b2e8a5.png";